import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';

const EmptyPackagePlaceholder: React.FC = () => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#9E9E9E',
        py: 8,
      }}
    >
      <img
        src='/admin/img/policy/dtbs/empty-package-placeholder.png'
        alt='empty-package-placeholder'
        style={{ marginBottom: 32 }}
      />
      <Stack
        spacing={1}
        sx={{ textAlign: 'center' }}
      >
        <Typography
          variant='h3'
          fontWeight={500}
          color='text.primary'
        >
          {t('dtbPackages.manageDtbs.emptyPackageTitle', "This package doesn't contain any DTB's yet")}
        </Typography>
        <Typography
          variant='body1'
          color='text.secondary'
        >
          {t('dtbPackages.manageDtbs.emptyPackageSubtitle', "Use the 'Add DTB' button to add new ones.")}
        </Typography>
      </Stack>
    </Box>
  );
};

export default EmptyPackagePlaceholder;
